import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import { DASHBOARDS_FORMS } from '../../../constants';
import { renderCounterPureContent } from '../renderers/counterPureRenderer';
import { eventCounterNumberComponentTransformer } from '../transformers/eventCounterNumberComponentTransformer';

import type { WidgetConfig } from './types';

export const counterNumberComponentConfig: WidgetConfig = {
  collectionName: FSCollections.COUNTER_CHARTS,
  componentType: DASHBOARDS_FORMS.EVENT_COUNTER_NUMBER_COMPONENT,
  op: API_OPERATIONS.EVENT_COMPONENT_COUNTER,

  buildParams: (queryParams, commonParams) => {
    if (!queryParams?.formId || !queryParams?.componentId) return null;

    return {
      ...commonParams,
      userIds: queryParams?.userIds || [],
      groupIds: queryParams?.groupIds || [],
      formId: queryParams?.formId || null,
      componentId: queryParams?.componentId || null,
      scheduleIds: queryParams?.scheduleIds || [],
      divisionIds: queryParams?.divisionIds || [],
      templateIds: queryParams?.templateIds || [],
      triggerId: queryParams?.triggerId || null,
      locationIds: queryParams?.locationIds || null,
      locationGroupId: queryParams.locationGroupId || null,
      type: queryParams?.type || null,
    };
  },
  transformData: eventCounterNumberComponentTransformer,
  renderContent: renderCounterPureContent,
};
